/**
 * ============================================================================
 * BAMBOOVE — KHỐI BEST SELLERS (port từ preview v52) — 04/10/2026
 * ----------------------------------------------------------------------------
 * Làm 4 việc:
 *  1) KÉO dải thẻ (≤749px): kéo bằng chuột/ngón tay như kéo trên điện thoại.
 *  2) Nút giỏ trên thẻ (điện thoại) ⇒ mở BẢNG CHỌN CỠ trượt từ đáy lên.
 *  3) Máy tính: rê chuột ⇒ thanh chọn cỡ hiện ra ⇒ BẤM 1 CỠ = thêm vào giỏ luôn.
 *  4) Thêm vào giỏ  ⇒ /cart/add.js  ⇒ vẽ lại ruột giỏ + MỞ GIỎ.
 *
 * Dùng ĐÚNG cơ chế giỏ đã có của dự án (xem `assets/bamboove-cart-drawer.js`):
 *   POST /cart/add.js  ·  kèm `sections: 'cart-drawer-section'`
 *   ⇒ máy chủ trả HTML mới  ⇒ thay `#cart-drawer .bb-gio`
 *   ⇒ bấm bong bóng số ở header theo `[ref="cartBubbleCount"]`.
 * KHÔNG file nào của theme bị sửa — đây là file JS RIÊNG của khối này.
 * ============================================================================
 */
(function () {
  'use strict';

  var ROOT = '.bamboove-bs';
  var SECTION = 'cart-drawer-section';
  var CART_ADD = '/cart/add.js';

  /* ------------------------------- TOAST ------------------------------- */
  var toastEl = null;
  var toastTimer = null;

  function taoToast() {
    if (toastEl && document.body.contains(toastEl)) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'bamboove-bs-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function baoChu(chu, loi) {
    var t = taoToast();
    t.textContent = chu;
    if (!loi) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '18');
      svg.setAttribute('height', '18');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2.4');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', 'M20 6 9 17l-5-5');
      svg.appendChild(p);
      t.insertBefore(svg, t.firstChild);
    }
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2500);
  }

  /* --------------------------- GIỎ (dùng chung) --------------------------- */
  function layRuotGio() {
    return document.querySelector('#cart-drawer .bb-gio');
  }

  /* /cart/add.js KHÔNG trả `item_count` (chỉ trả mảng items) ⇒ hỏi /cart.js cho chắc.
     (bài học phát hiện 04/10/2026 — xem `.memory/lessons/289-*.md`) */
  async function laySoGio(gioHang) {
    var dem = gioHang && gioHang.item_count;
    if (typeof dem === 'number') return dem;
    try {
      var c = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
      if (c && typeof c.item_count === 'number') return c.item_count;
    } catch (e) { /* mạng lỗi ⇒ thôi */ }
    return 0;
  }

  function capNhatSoGio(gioHang) {
    var dem = (gioHang && gioHang.item_count) || 0;
    document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function (e) {
      e.textContent = dem < 100 ? String(dem) : '';
      e.classList.toggle('hidden', dem === 0);
    });
    document.querySelectorAll('[ref="cartBubble"]').forEach(function (e) {
      e.classList.toggle('visually-hidden', dem === 0);
    });
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(dem), timestamp: Date.now() }));
    } catch (e) { /* trình duyệt chặn sessionStorage */ }
  }

  /* Cong tac o trinh soan theme: tat thi thoi, khong mo gi.
     Duong di (theo dung Bamboove): ① `.open()` cua <theme-drawer id="cart-drawer">
     ② `Shopify.actions.openCart` (ban override cua Bamboove: khong co ngan keo thi tu ve /cart)
     ③ hien <dialog> bang `showModal`  ④ cung duong ve /cart. */
  function choMoGio() {
    var khoi = document.querySelector(ROOT);
    return !khoi || khoi.getAttribute('data-bs-mo-gio') !== '0';
  }

  function moGio() {
    if (!choMoGio()) return;
    var d = document.querySelector('#cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return; }
    var a = window.Shopify && window.Shopify.actions;
    if (a && typeof a.openCart === 'function') { a.openCart(); return; }
    if (d && typeof d.showModal === 'function' && !d.open) { d.showModal(); return; }
    window.location.href = '/cart';
  }

  async function themVaoGio(variantId, ten, tenCo, nguonBay, anhBay) {
    if (!variantId) { baoChu('Hết hàng ở cỡ này', true); return false; }
    /* (76f) Đang chạy 1 lệnh đổi giỏ khác? ⇒ BỎ QUA cú bấm này (y Horizon: khi đang cập nhật
       thì khoá nhận lệnh mới — tránh 2 phản hồi về ngược thứ tự làm giỏ “quay lui”). */
    if (window.bambooveGio && window.bambooveGio.dangChay && window.bambooveGio.dangChay()) {
      return false;
    }
    /* (76c) BAY VÀO GIỎ — học Horizon `fly-to-cart`: bấm là bay NGAY, không chờ mạng */
    if (window.bambooveBayGio && nguonBay) {
      window.bambooveBayGio({ nguon: nguonBay, anh: anhBay || '', loai: 'quick' });
    }
    try {
      /* (11/10/2026 · p53) MỞ NGĂN KÉO NGAY khi bắt đầu thêm — khách KHÔNG phải chờ mạng.
         Ruột giỏ được vá lại ngay khi máy chủ trả lời (~1 nhịp), trong lúc chờ đã có
         vòng xoay `.bb-gio__ban` che. Trước đây mở sau 4,4–5,1 giây (đo thật p53). */
      /* (76e) HỌC HORIZON — mở giỏ THÔNG MINH, bỏ vòng xoay “đang load”:
         giỏ ĐÃ CÓ HÀNG ⇒ mở NGAY (khỏi chờ mạng); giỏ TRỐNG ⇒ gác lại, mở khi hàng mới về
         (`moTruocKhiThem` + cờ `choMoSau` trong `bamboove-cart-drawer.js`). */
      if (window.bambooveGio) {
        window.bambooveGio.ban(true);
        if (window.bambooveGio.moTruocKhiThem) window.bambooveGio.moTruocKhiThem();
        else window.bambooveGio.mo();
      }
      var tra = await fetch(CART_ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: SECTION })
      });
      if (!tra.ok) throw new Error('HTTP ' + tra.status);
      var gioHang = await tra.json();

      var html = gioHang && gioHang.sections && gioHang.sections[SECTION];
      if (html && window.bambooveGio) {
        window.bambooveGio.thayRuot(html);   /* 1 mối lo việc thay ruột giỏ (p53) */
      } else if (html) {
        var tai = new DOMParser().parseFromString(html, 'text/html');
        var moi = tai.querySelector('.bb-gio');
        var cu = layRuotGio();
        if (moi && cu) cu.replaceWith(moi);
      }
      capNhatSoGio({ item_count: await laySoGio(gioHang) });
      if (window.bambooveGio) window.bambooveGio.ban(false);
      moGio();
      baoChu('Đã thêm vào giỏ' + (tenCo ? ' · ' + tenCo : ''));
      return true;
    } catch (e) {
      baoChu('Không thêm được vào giỏ. Bạn thử lại nhé.', true);
      if (window.bambooveGio) window.bambooveGio.ban(false);
      return false;
    }
  }

  window.bambooveBS = { themVaoGio: themVaoGio, baoChu: baoChu };

  /* ======================================================================
     (08/10/2026 · p49) CỠ ĐÃ HẾT ⇒ DẪN KHÁCH SANG TRANG SẢN PHẨM
     ----------------------------------------------------------------------
     Vì sao: khách muốn cỡ đó mà hết hàng thì mình phải cho họ ĐỂ LẠI EMAIL
     (khối "báo khi có hàng lại" của PDP). Ô nhập email KHÔNG đặt trên thẻ vì
     form khách hàng của Shopify có hCaptcha ẩn + mỗi trang chỉ nên 1 form.
     Lấy link gốc ở `a.card-title` / `a.media-link` (thẻ màu tự mang ?variant=<màu>);
     có id cỡ thì thay bằng ĐÚNG biến thể cỡ đó ⇒ PDP mở đúng màu+cỡ và khối
     báo-hàng-về tự hiện (PDP đọc `available` của biến thể ⇒ false).
     ====================================================================== */
  function diPDP(card, variantId) {
    if (!card) return;
    var a = card.querySelector('.card-title a') || card.querySelector('a.media-link');
    var url = (card.getAttribute('data-bs-url') || (a && a.getAttribute('href')) || '').trim();
    if (!url || url === '#') return;
    var goc = url.split('?')[0];
    window.location.href = (variantId && String(variantId).length)
      ? goc + '?variant=' + encodeURIComponent(variantId)
      : url;
  }
  window.bambooveDiPDP = diPDP;

  /** (76c) Ảnh của thẻ sản phẩm — nguồn cho hiệu ứng “bay vào giỏ”. */
  function anhThe(card) {
    if (!card) return '';
    var im = card.querySelector('.card-media img');
    return im ? (im.currentSrc || im.src || '') : '';
  }

  /* ====================== BẢNG CHỌN CỠ TRƯỢT ĐÁY ====================== */
  var sheet = null, overlay = null, listEl = null, addBtn = null, noteEl = null, titleEl = null;
  var theDangMo = null;
  var dangChon = null;   /* { variant, size } */
  var hetSach = false;   /* (p49) thẻ đang mở đã HẾT SẠCH: mọi cỡ đều gạch */

  var SVG_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function dungSheet() {
    if (sheet && document.body.contains(sheet)) return;

    overlay = document.createElement('div');
    overlay.className = 'bamboove-bs-sheet-overlay';

    sheet = document.createElement('div');
    sheet.className = 'bamboove-bs-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML =
      '<div class="bamboove-bs-sheet__head">' +
        '<h3 class="bamboove-bs-sheet__title">Choose size</h3>' +
        '<button type="button" class="bamboove-bs-sheet__close" aria-label="Close">' + SVG_X + '</button>' +
      '</div>' +
      '<div class="bamboove-bs-sheet__body"></div>' +
      '<p class="bamboove-bs-sheet__note" hidden>Please choose a size first.</p>' +
      '<div class="bamboove-bs-sheet__foot">' +
        '<button type="button" class="bamboove-bs-sheet__add">Add to bag</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(sheet);

    listEl = sheet.querySelector('.bamboove-bs-sheet__body');
    addBtn = sheet.querySelector('.bamboove-bs-sheet__add');
    noteEl = sheet.querySelector('.bamboove-bs-sheet__note');
    titleEl = sheet.querySelector('.bamboove-bs-sheet__title');

    sheet.querySelector('.bamboove-bs-sheet__close').addEventListener('click', dongSheet);
    overlay.addEventListener('click', dongSheet);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dongSheet();
    });

    /* chọn cỡ */
    listEl.addEventListener('click', function (e) {
      var row = e.target.closest('.bamboove-bs-sheet__row');
      if (!row) return;
      /* (p49) dòng HẾT HÀNG: không chọn được, nhưng BẤM ĐƯỢC ⇒ sang PDP để lại email */
      if (row.classList.contains('is-soldout')) {
        diPDP(theDangMo, row.dataset.variant);
        return;
      }
      listEl.querySelectorAll('.bamboove-bs-sheet__row').forEach(function (r) { r.classList.remove('is-selected'); });
      row.classList.add('is-selected');
      dangChon = { variant: row.dataset.variant, size: row.dataset.size };
      noteEl.hidden = true;
      listEl.classList.remove('is-error');
      addBtn.textContent = 'Add to bag · ' + dangChon.size;
    });

    /* thêm vào giỏ */
    addBtn.addEventListener('click', async function () {
      /* (p49) CẢ sản phẩm đã hết ⇒ nút này là "Notify me": dẫn sang PDP để lại email */
      if (hetSach) {
        var theCu = theDangMo;
        var dau = theCu ? theCu.querySelector('.size-picker button.soldout') : null;
        var idDau = dau ? dau.getAttribute('data-bs-variant') : '';
        dongSheet();
        diPDP(theCu, idDau);
        return;
      }
      if (!dangChon || !dangChon.variant) {
        noteEl.hidden = false;
        listEl.classList.add('is-error');
        return;
      }
      var theBay = theDangMo;
      var ten = theBay ? (theBay.querySelector('.card-title')?.textContent?.trim() || '') : '';
      var xong = await themVaoGio(dangChon.variant, ten, dangChon.size, addBtn, anhThe(theBay));
      if (xong) dongSheet();
    });
  }

  function moSheet(card) {
    dungSheet();
    theDangMo = card;
    dangChon = null;
    noteEl.hidden = true;
    listEl.classList.remove('is-error');
    addBtn.textContent = 'Add to bag';

    var ten = card.querySelector('.card-title') ? card.querySelector('.card-title').textContent.trim() : '';
    titleEl.textContent = ten || 'Choose size';

    listEl.innerHTML = '';
    hetSach = false;
    var nutCo = card.querySelectorAll('.size-picker button');
    if (!nutCo.length) {
      theDangMo = null;
      return;
    }
    var conCo = 0;   /* (p49) đếm cỡ CÒN HÀNG ⇒ biết khi nào cả thẻ đã hết sạch */
    nutCo.forEach(function (b) {
      var sold = b.classList.contains('soldout');
      if (!sold) conCo++;
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'bamboove-bs-sheet__row' + (sold ? ' is-soldout' : '');
      row.dataset.variant = b.getAttribute('data-bs-variant') || '';
      row.dataset.size = b.getAttribute('data-bs-size') || '';

      var nhan = document.createElement('span');
      nhan.textContent = row.dataset.size;
      row.appendChild(nhan);

      if (sold) {
        var ton = document.createElement('span');
        ton.className = 'bamboove-bs-sheet__stock';
        /* (p49) bấm được ⇒ mời khách sang PDP để lại email */
        ton.textContent = 'Out of stock · Notify me';
        row.appendChild(ton);
      }
      listEl.appendChild(row);
    });
    /* (p49) hết sạch ⇒ nút dưới đổi thành "Notify me when it is back" (dẫn sang PDP) */
    hetSach = conCo === 0;
    addBtn.textContent = hetSach ? 'Notify me when it is back' : 'Add to bag';

    overlay.classList.add('is-open');
    sheet.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function dongSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    theDangMo = null;
  }

  /* ========== KÉO DẢI THẺ (≤749px) — HÚT + QUÁN TÍNH (bản v52 đã chốt) ==========
     Bản v52 làm 3 việc; lần port đầu 04/10 đánh rơi ② và ③ (bài học #291):
       ① NGÓN TAY: KHÔNG can thiệp ⇒ trình duyệt tự cuộn CÓ QUÁN TÍNH, rồi
          `scroll-snap-type` của CSS tự HÚT về đầu thẻ — lướt MẠNH ⇒ qua nhiều thẻ.
       ② CHUỘT (khổ hẹp): tự làm quán tính theo VẬN TỐC — buông chuột không "khựng".
       ③ Buông chuột ⇒ HÚT về mốc thẻ gần nhất (không dừng lửng giữa 2 thẻ).
     Lúc kéo bằng chuột thì TẮT snap: vừa ghi `scrollLeft` vừa để snap bật thì
     trình duyệt giật lại từng khung hình. Buông ra mới bật lại + chốt mốc.
     ============================================================================ */
  function ganKeo() {
    document.querySelectorAll(ROOT + ' [data-bs-grid]').forEach(function (grid) {
      if (grid.dataset.bsKeo) return;
      grid.dataset.bsKeo = '1';

      var dangKeo = false, x0 = 0, sl0 = 0, daDi = 0, lichSu = [], quanTinh = 0;

      /* ảnh/link: cấm trình duyệt kéo-thả (không thì cú kéo bị CẮT giữa đường — như v52) */
      grid.querySelectorAll('a, img').forEach(function (el) { el.setAttribute('draggable', 'false'); });

      /* MỐC HÚT = các giá trị `scrollLeft` để thẻ i nằm ĐÚNG lề trong của dải.
         (thẻ 1 ⇒ mốc 0 ⇒ lúc dừng yên hình KHÔNG đổi so với trước) */
      function layMoc() {
        var pad = parseFloat(getComputedStyle(grid).paddingInlineStart) || 0;
        var gb = grid.getBoundingClientRect();
        var toiDa = Math.max(0, grid.scrollWidth - grid.clientWidth);
        var muc = [];
        for (var i = 0; i < grid.children.length; i++) {
          var c = grid.children[i];
          var v = Math.round(c.getBoundingClientRect().left - gb.left + grid.scrollLeft - pad);
          muc.push(Math.max(0, Math.min(toiDa, v)));
        }
        return muc;
      }

      /* buông tay ⇒ bật snap lại cho trình duyệt + tự chốt về mốc gần nhất */
      function hutVao() {
        grid.style.scrollSnapType = '';
        grid.style.scrollBehavior = '';
        var muc = layMoc();
        if (!muc.length) return;
        var gan = muc[0];
        for (var i = 1; i < muc.length; i++) {
          if (Math.abs(muc[i] - grid.scrollLeft) < Math.abs(gan - grid.scrollLeft)) gan = muc[i];
        }
        if (Math.abs(gan - grid.scrollLeft) > 1) {
          grid.scrollTo({ left: gan, behavior: 'smooth' });
        }
      }

      grid.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;                      /* ① ngón tay: NHƯỜNG trình duyệt */
        if (window.matchMedia('(min-width:750px)').matches) return; /* khổ rộng: lưới tĩnh, không kéo */
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest && e.target.closest('.card-quickadd')) return;
        if (grid.scrollWidth <= grid.clientWidth + 2) return;
        if (quanTinh) { cancelAnimationFrame(quanTinh); quanTinh = 0; }
        dangKeo = true;
        daDi = 0;
        x0 = e.clientX;
        sl0 = grid.scrollLeft;
        lichSu = [{ t: performance.now(), x: e.clientX }];
        grid.style.scrollSnapType = 'none';                          /* ② kéo tự do, không bị snap giật */
        grid.style.scrollBehavior = 'auto';
        /* ⚠️ BÀI HỌC (phiên 76 d): KHÔNG `setPointerCapture` — capture làm cú BẤM vào
           ẢNH/TÊN thẻ @≤749px (chuột) bị “nuốt” (đo: đích click nhảy lên cả LƯỚI thay vì <a>
           ⇒ khách không sang trang sản phẩm). Kéo theo dõi bằng listener trên `window`. */
        grid.style.cursor = 'grabbing';
      });

      window.addEventListener('pointermove', function (e) {
        if (!dangKeo) return;
        var dx = e.clientX - x0;
        if (Math.abs(dx) > daDi) daDi = Math.abs(dx);
        grid.scrollLeft = sl0 - dx;                                 /* bám 1:1 theo con trỏ */
        lichSu.push({ t: performance.now(), x: e.clientX });
        if (lichSu.length > 6) lichSu.shift();
        if (daDi > 6) e.preventDefault();
      });

      /* ②③ buông chuột ⇒ TRƯỢT QUÁN TÍNH (ma sát .94 · 16,7ms/khung — y như v52) rồi HÚT */
      function ketThuc() {
        if (!dangKeo) return;
        dangKeo = false;
        grid.style.cursor = '';
        if (daDi <= 6) { hutVao(); return; }                        /* bấm chứ không kéo ⇒ trả snap lại */
        var dau = lichSu[0], cuoi = lichSu[lichSu.length - 1];
        var dt = cuoi.t - dau.t;
        var vanToc = (dt > 0 && lichSu.length >= 3) ? (cuoi.x - dau.x) / dt : 0;  /* px/ms */
        if (Math.abs(vanToc) < 0.25) { hutVao(); return; }          /* kéo chậm ⇒ hút luôn, không trượt */
        (function buoc() {
          vanToc *= 0.94;
          grid.scrollLeft -= vanToc * 16.7;
          if (Math.abs(vanToc) > 0.05) { quanTinh = requestAnimationFrame(buoc); }
          else { quanTinh = 0; hutVao(); }
        })();
      }
      grid.addEventListener('pointerup', ketThuc);
      window.addEventListener('pointerup', ketThuc);
      window.addEventListener('pointercancel', ketThuc);
      grid.addEventListener('pointerleave', ketThuc);

      /* kéo > 6px ⇒ CHẶN cú bấm (không mở nhầm trang sản phẩm) */
      grid.addEventListener('click', function (e) {
        if (daDi > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* ============================ GẮN SỰ KIỆN ============================ */
  function ganNut() {
    if (document.body.dataset.bsNut) return;
    document.body.dataset.bsNut = '1';

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      /* 1) NÚT GIỎ GÓC PHẢI TRÊN THẺ (điện thoại) ⇒ MỞ QUICK-ADD GỐC CỦA HORIZON
         (76 g · 17/10/2026 — anh Trung: “tất cả những cái thẻ … có nút thêm sản phẩm ở góc phải trên …
         tôi đang muốn đổi hết thành dạng pop up hiện lên, xong thêm nhanh”).
         Nối sang `window.bambooveQuickAdd` của `assets/bamboove-cart-drawer.js` (modal gốc: ảnh ·
         tên + giá · size chip · số lượng −1+ · Add to cart · Shop Pay · More payment options).
         Trang KHÔNG có khối nối (vd trang giỏ) hoặc JS Horizon chưa nạp ⇒ LÙI về bảng chọn cỡ
         trượt đáy cũ (`moSheet`) — không để nút chết. */
      var nutGio = e.target.closest(ROOT + ' .card-quickadd button');
      if (nutGio) {
        e.preventDefault();
        e.stopPropagation();
        var card = nutGio.closest('.product-card');
        if (card) {
          var qa = window.bambooveQuickAdd;
          var handle = card.getAttribute('data-product-handle') || '';
          var oTen = card.querySelector('.card-title');
          if (handle && qa && typeof qa.mo === 'function' && qa.mo(handle, oTen ? oTen.textContent.trim() : '')) {
            return;
          }
          moSheet(card);
        }
        return;
      }

      /* 2) máy tính: bấm 1 CỠ trong thanh chọn cỡ ⇒ thêm vào giỏ luôn */
      var nutCo = e.target.closest(ROOT + ' .size-picker button');
      if (nutCo) {
        e.preventDefault();
        e.stopPropagation();
        /* (08/10/2026 · p49) CỠ ĐÃ HẾT (có gạch ngang) ⇒ KHÔNG thêm vào giỏ, mà ĐƯA
           KHÁCH SANG TRANG SẢN PHẨM kèm `?variant=<id>` để khối "báo khi có hàng lại"
           tự hiện cho đúng cỡ đó (đo thật: bấm cỡ gạch ⇒ PDP + ?variant= + khối tự hiện). */
        if (nutCo.classList.contains('soldout')) {
          diPDP(nutCo.closest('.product-card'), nutCo.getAttribute('data-bs-variant'));
          return;
        }
        if (nutCo.disabled) return;
        var c = nutCo.closest('.product-card');
        var ten = c && c.querySelector('.card-title') ? c.querySelector('.card-title').textContent.trim() : '';
        themVaoGio(nutCo.getAttribute('data-bs-variant'), ten, nutCo.getAttribute('data-bs-size'), nutCo, anhThe(c));
      }
    }, true);
  }

  function chay() {
    ganKeo();
    ganNut();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chay);
  } else {
    chay();
  }
  /* trình soạn theme vẽ lại section ⇒ gắn lại */
  document.addEventListener('shopify:section:load', chay);
})();
